import React from 'react';
import givebutterLogotype from 'assets/img/givebutter-logotype.svg';

const ErrorScreen = (props: React.PropsWithChildren) => {
  return (
    <div className="flex h-full w-full flex-col items-center justify-center p-12">
      <img
        className={`absolute left-0 right-0 top-12 m-auto md:left-12 md:top-12 md:m-[initial]`}
        src={givebutterLogotype}
        alt="Givebutter logo"
      />
      {props.children}
    </div>
  );
};

export { ErrorScreen };
